import { memo } from 'react';

import type { FileUploadActionField, BaseTypeProps } from 'schemaBuilder/types';

import { TypeWrapper } from '../../ui';

import FileUploadBody from './body';

export interface Props extends BaseTypeProps {
  field: FileUploadActionField;
}

export const FileUpload = ({
  isDragging,
  field,
  dragElement,
  removeElement,
  typeSelectElement,
  fieldKeyElement,
  path,
  theme,
  readonly
}: Props) => {
  return (
    <TypeWrapper
      readonly={readonly}
      schemaField={field.schemaField}
      required={field.required}
      isDragging={isDragging}
      dragElement={dragElement}
      typeSelectElement={typeSelectElement}
      removeElement={removeElement}
      fieldKeyElement={fieldKeyElement}
      path={path}
      theme={theme}
    >
      <FileUploadBody
        readonly={readonly}
        schemaField={field.schemaField}
        path={path}
      />
    </TypeWrapper>
  );
};

export default memo(FileUpload);
